import { render, staticRenderFns } from "./saldiscounttable.vue?vue&type=template&id=c3700f6a&scoped=true&"
import script from "./saldiscounttable.vue?vue&type=script&lang=js&"
export * from "./saldiscounttable.vue?vue&type=script&lang=js&"
import style0 from "./saldiscounttable.vue?vue&type=style&index=0&id=c3700f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3700f6a",
  null
  
)

export default component.exports